// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1P2Vz","left":"styles_left__HY3fB"};